import React from 'react'
import Modal from '@mui/material/Modal'
import { Box, Typography } from '@mui/material'
import { IconInfor } from '../../../../assets/icons_svg'
import { CustomButton } from 'components/CustomButton'

export default ({ currErr, themeColor, open = true }) => (
    <Modal
        open={open}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        disableEnforceFocus
        sx={{ backdropFilter: 'blur(2px)' }}
    >
        <Box
            sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '90%',
                maxWidth: 470,
                bgcolor: '#FFFFFF',
                p: '35px 25px 25px',
                borderRadius: '10px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '20px',
            }}
        >
            <IconInfor
                sx={{
                    fontSize: '72px !important',
                    color: themeColor?.visual?.icons?.color || '#eea236',
                }}
            />
            <Typography
                color="#5D5D5D"
                fontSize="15px"
                fontWeight={500}
                textAlign="center"
                lineHeight="1.6"
            >
                {currErr?.content || ''}
            </Typography>
            <CustomButton
                size="sm"
                variant="contained"
                defaultColor={themeColor?.navigation?.buttons?.backgroundColor || '#5CB860'}
                onClick={currErr?.onConfirm}
                style={{ minWidth: '140px' }}
            >
                {currErr?.confirmBtnText || 'Ok'}
            </CustomButton>
        </Box>
    </Modal>
)
